<template>
  <div class="ex-res-card-header">
    <div class="ml-3">
      <Breadcrumbs 
        :breadcrumbsList="props.breadcrumbs" 
        @onClickBreadcrumb="handleBreadcrumbClick"
      />
    </div>
    <OrgObjectHeader
      type="Responsibility"
      :status="status"
      :code="code"
      :name="name"
      :archived="archived"
      :lockShow="false"
      :currentPosition="currentResponsibility"
      :dataStream="dataStream"
      :readiness="avg_readiness"
      :last_month_readiness="last_month_readiness"
      :totalChatterCount="totalChatterCount"
      :chatterDrawerOpen="chatterDrawerOpen"
      @update:chatterDrawerOpen="$emit('update:chatterDrawerOpen', $event)"
      @reloadChatterList="$emit('reloadChatterList')"
      @requestMoreCheckpointsChatter="$emit('requestMoreCheckpointsChatter', $event)"
      @optionClick="$emit('optionClick', $event)"
    />
    <!-- <div class="avg-readiness">
      <ResponsibilityAvgReadinessBanner :readiness="validatedReadiness" />
    </div> -->
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import OrgObjectHeader from "@components/OrgObjectHeader/OrgObjectHeader.vue";
import Breadcrumbs from "@components/breadcrumbs/ExBreadcrumbs.vue";
import ResponsibilityAvgReadinessBanner from '@components/ResponsibilityAvgReadinessBanner/ResponsibilityAvgReadinessBanner.vue';
const props = defineProps({
  breadcrumbs: {
    type: Array,
    default: () => [
      {
        text: "Responsibilities",
        href: "" // Empty href - navigation handled via backToList emit
      },
      {
        text: "Responsibility",
        href: "",
        disabled: true
      }
    ]
  },
  status: {
    type: String,
    default: ''
  },
  code: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  archived: {
    type: Boolean,
    default: false
  },
  avg_readiness: {
    type: Number,
    default: 0
  },
  last_month_readiness: {
    type: Number,
    default: 0
  },
  dataStream: {
    type: Array,
    default: () => []
  },
  totalChatterCount: {
    type: Number,
    default: 0
  },
  currentResponsibility: {
    type: Object,
    default: () => ({})
  },
  chatterDrawerOpen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['reloadChatterList', 'requestMoreCheckpointsChatter', 'optionClick', 'backToList', 'update:chatterDrawerOpen']);

const handleBreadcrumbClick = (breadcrumb) => {
  emit('backToList', breadcrumb);
};

const validatedReadiness = computed(() => {
  const maxValue = 150; // Defined in ReadinessBar component
  return Math.min(props.avg_readiness, maxValue);
});
</script>
<style>
.ex-res-card-header .employee_availability_icon {
  width: auto;
  margin-top: 1px;
}
.ex-res-card-header .code-text {
  color: #98A2B3;
}
.ex-res-card-header .avg-readiness {
  margin-top: 8px;
  padding: 0px 35px 0px 15px;
}
</style>